import React from 'react';
import LazyLoad from '../../services/lazyLoad';
import { TIERS } from '../../utils/subscription';
import connect from './connect';
import LargeBanner from '../../components/common/Subscription/BecomePremiumTopBar/BigBanner';
import { useSubscriptionPermission } from '../../hooks/useSubscriptionPermission';

const DemoDashboard = LazyLoad({ loader: () => import('./Dashboard') });
const LimitedDashboard = LazyLoad({ loader: () => import('./LimitedDashboard') });

function Dashboard({ subscription }) {
  const { hasPermission } = useSubscriptionPermission('demo-dashboard');

  return (
    <>
      <LargeBanner permissionKey="demo-dashboard" />

      <div className={!hasPermission ? 'blurNotSubscribed' : ''}>
        {subscription?.data?.currentPlan === TIERS.LIMITED ? <LimitedDashboard /> : <DemoDashboard />}
      </div>
    </>
  );
}

export default connect(Dashboard);
